import { SharedMeetingAttendeesModule } from '@morningstar/shared/meeting-attendees';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MeetingRoomUtilizationComponent } from './meeting-room-utilization/meeting-room-utilization.component';
import { MeetingRoomService } from './meeting-room.service';
import { WsgSharedModule }  from '@morningstar/wsg/shared';
import { ColumnSeriesService, ChartModule } from '@syncfusion/ej2-angular-charts';
import { LocationsModule } from 'apps/wsg/src/app/shared/locations/locations.module';
import { MeetingRoomRequirementsComponent } from './meeting-room-requirements/meeting-room-requirements.component';
import { MeetingArrivalsComponent } from './meeting-arrivals/meeting-arrivals.component';

@NgModule({
  declarations: [
    MeetingRoomUtilizationComponent,
    MeetingRoomRequirementsComponent,
    MeetingArrivalsComponent,
  ],
  imports: [
    CommonModule,
    WsgSharedModule,
    LocationsModule,
    ChartModule,
    SharedMeetingAttendeesModule
  ],
  providers: [
    MeetingRoomService,
    ColumnSeriesService
  ],
  exports: [
    MeetingRoomUtilizationComponent,
    MeetingRoomRequirementsComponent
  ]
})
export class MeetingRoomsModule { }
